import data from "../../../../../src/PageLayout/PageLayout.docs.json";
import * as React from 'react';
export default {
  data,
  React
};